import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
	iconfont: 'md',
	theme: {
		primary: colors.red.darken4,
		secondary: colors.grey.lighten3,
		accent: colors.blueGrey.lighten2
	},
	options: {//Needed for generating css color vars from theme
		customProperties: true
	},
})
